var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-main-nav__faq" }, [
    _c("h2", [_vm._v(_vm._s(_vm.faq.title))]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "c-main-nav__faq-list" },
      _vm._l(_vm.faqArray, function(item, i) {
        return _c("li", { key: i, staticClass: "c-main-nav__faq-item" }, [
          _c(
            "a",
            { staticClass: "c-main-nav__faq-link", attrs: { href: item.url } },
            [_vm._v("\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.faq.readMoreUrl && _vm.faq.readMoreText
      ? _c(
          "a",
          {
            staticClass:
              "c-button c-button--ghost c-button--noboxshadow c-button--icon c-main-nav__faq-button",
            attrs: { href: _vm.faq.readMoreUrl }
          },
          [
            _c("span", { staticClass: "c-button--right" }, [
              _vm._v(_vm._s(_vm.faq.readMoreText))
            ]),
            _vm._v(" "),
            _c("v-icon", { attrs: { name: "icon-arrow-circle", size: "m" } })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }